import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";

import ReCAPTCHA from "react-google-recaptcha";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Content from "./layout/Content";
import "./Login.css";
import {InputText} from "primereact/inputtext";
import {Password} from "primereact/password";

const Login = ({classes, ...props}) => {
    return (
        <React.Fragment>
            <div className="containerLogin">
                <div className="backGroundLogin">
                    <div className="containerForm">
                        <form onSubmit={props.signUp}>
                            Usuario
                            <div className={"fieldsDiv"}>
                                <InputText name="username"
                                           required={true}
                                           maxLength={15}
                                           onChange={props.updateUsername}
                                           value={props.username}
                                           autoFocus/>
                            </div>
                            Contraseña
                            <div className={"fieldsDiv"}>
                                <Password name="password"
                                          feedback={false}
                                          required={true}
                                          value={props.password}
                                          onChange={props.updatePassword}
                                          maxLength={15}
                                />
                            </div>
                            <div className={"fieldsDiv"}>
                                <ReCAPTCHA
                                    sitekey={props.token}
                                    size={"compact"}
                                    onChange={props.onChangeRecaptcha}
                                />
                            </div>
                            <div className={"fieldsDiv"}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    type="submit"
                                    disabled={props.disabledLogin}
                                >
                                    Login
                                </Button>
                            </div>
                        </form>
                    </div>

                    <div
                        style={{
                            height: "100%",
                            width: "20px",
                            textAlign: "center",
                            display: "inline-block",
                        }}
                    ></div>
                </div>
            </div>
            <Header/>
            <div className="container-fluid">
                <div className="body-container">
                    <Content/>
                </div>
            </div>
            <Footer version={props.version}/>
        </React.Fragment>
    );
};

const styles = (theme) => ({});

export default withStyles(styles, {withTheme: true})(Login);
